import type {
  Account,
  GcpDiskSnapshotProperties,
  InventoryResource,
  Snapshot,
} from '@repo/api-gw-sdk';
import { Provider } from '@repo/api-gw-sdk';

import { GcpDiskConfiguration } from './steps/gcp/gcpDiskConfiguration';
import { SelectTargetAccountStep } from './steps/selectTargetAccount';

import type { Step } from '../wizard/Step';
import { Wizard } from '../wizard/Wizard';

export interface RestoreGcpDiskState {
  resourceId: string;
  snapshot: Snapshot;
  supportedCloudProviders: Provider[];
  restoreAccount?: Account;
  originalDiskSettings: GcpDiskSnapshotProperties;
  regionName?: string;
  originalTags: Record<string, string>;
  zone?: string;
  encryptionKey?: string;
  machineType: string;
}

const restoreGcpDiskFlow: Step<RestoreGcpDiskState> = {
  name: 'SelectTargetAccountStep',
  Component: SelectTargetAccountStep,
  next: [
    {
      name: 'GcpDiskConfiguration',
      Component: GcpDiskConfiguration,
    },
  ],
};

export const RestoreGcpDiskWizard = ({
  resource,
  snapshot,
  disk,
  onClose,
  onBack,
}: {
  resource: InventoryResource;
  snapshot: Snapshot;
  disk: GcpDiskSnapshotProperties;
  onClose: () => void;
  onBack: () => void;
}) => {
  const machineType =
    snapshot.resource?.properties?.gcpVm?.machineType?.split('/')?.pop() || '';

  return (
    <Wizard<RestoreGcpDiskState>
      onAbort={(origin) => (origin === 'back' ? onBack() : onClose())}
      onFinish={async () => true}
      flow={[restoreGcpDiskFlow]}
      initialState={{
        snapshot,
        resourceId: resource.id,
        supportedCloudProviders: [Provider.Gcp],
        originalDiskSettings: {
          ...disk,
          diskName: `${disk.diskName ?? ''}-restored`,
        },
        originalTags: { ...disk.tags },
        machineType,
      }}
      title={`Restore Disk`}
      stepperLabels={['Restore account', 'Disk configuration']}
    />
  );
};
